import { NavLink, Outlet } from 'react-router-dom';
import { Navigation } from 'ui-rollup';
import styles from './App.module.css';
import clsx from 'clsx';
import 'react-loading-skeleton/dist/skeleton.css';

export const AppOutlet = () => {
  return (
    <div className={styles.app}>
      <div>
        <Navigation title="Invoicer (alpha)">
          <div className={styles.navigationSection}>
            {['dashboard', 'create', 'history', 'clients'].map((page) => {
              return (
                <NavLink
                  key={page}
                  className={({ isActive }) =>
                    isActive
                      ? clsx(styles.navigationItem, styles.active)
                      : clsx(styles.navigationItem)
                  }
                  to={page}
                >
                  {page.charAt(0).toUpperCase() + page.slice(1)}
                </NavLink>
              );
            })}
          </div>
          <div className={styles.navigationSection}>
            <NavLink
              className={styles.navigationItem}
              to=""
              onClick={() => sessionStorage.clear()}
            >
              Logout
            </NavLink>
          </div>
        </Navigation>
      </div>
      <div className={styles.container}>
        <Outlet />
      </div>
    </div>
  );
};
